/**
 * @module config/terms
 * @description Terms and Conditions text, shown at #/terms and linked from
 * the pledge form.
 *
 * // TEMPORARY: placeholder until AFJ supplies the text (Samantha, 2026-10-01:
 * "Add a Terms and Conditions tab. I will supply the text.").
 * What caused this: the tab and links are requested now; the wording is AFJ's.
 * Why chosen: a clearly labeled holding page is truthful and lets the route,
 * navigation and pledge checkbox be reviewed today. Side-effects: the page
 * states that the terms are being finalized until `TERMS.sections` is filled.
 */
export interface TermsSection {
    heading: string;
    paragraphs: string[];
}

export interface TermsContent {
    /** e.g. "October 2026". Empty until AFJ supplies the text. */
    lastUpdated: string;
    sections: TermsSection[];
}

export const TERMS: TermsContent = {
    lastUpdated: "",
    sections: [],
};
